module.exports = __webpack_public_path__ + "img/6_no.ca22ad73.svg";